import React from 'react';
import { sizes } from '../theme';

interface AppleSignInButtonProps {
  onClick: () => void;
  loading: boolean;
  text?: string;
}

const AppleSignInButton: React.FC<AppleSignInButtonProps> = ({ 
  onClick, 
  loading, 
  text = "Continuer avec Apple" 
}) => {
  const styles = {
    button: {
      height: `${sizes.inputHeight}px`,
      backgroundColor: '#000000',
      color: '#ffffff',
      border: 'none',
      borderRadius: `${sizes.buttonRadius}px`,
      fontSize: `${sizes.p}px`,
      fontWeight: 'bold' as const,
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      opacity: loading ? 0.7 : 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
      width: '100%',
      position: 'relative' as const,
    },
    buttonHover: {
      backgroundColor: '#1a1a1a',
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
    },
    icon: {
      width: '20px',
      height: '20px',
      fill: 'currentColor',
    },
    text: {
      fontSize: `${sizes.text}px`,
      fontWeight: '500',
    }
  };

  return (
    <button
      onClick={onClick}
      disabled={loading}
      style={styles.button}
      onMouseEnter={(e) => {
        if (!loading) {
          Object.assign(e.currentTarget.style, styles.buttonHover);
        }
      }}
      onMouseLeave={(e) => {
        Object.assign(e.currentTarget.style, {
          backgroundColor: '#000000',
          transform: 'none',
          boxShadow: 'none',
        });
      }}
    >
      {/* Icône Apple */}
      <svg style={styles.icon} viewBox="0 0 24 24">
        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
      </svg>
      <span style={styles.text}>
        {loading ? 'Connexion...' : text}
      </span>
    </button>
  );
};

export default AppleSignInButton;